// import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
import { faShippingFast } from "@jewlr/sharp-light-svg-icons/faShippingFast"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons/faBoxHeart"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { jewlr_t, IS_JEWLR } from "helpers/application"
import { showHolidayShippingInfoPDP } from "helpers/holiday"
import { cn } from "styles/utils"

const Title = () => {
  const holidayDelivery = useSelector(
    (state) => state.wizard.shipping.main?.available_holiday_delivery
  )
  const isAccessory = useSelector(
    (state) => state.wizard.description.product_type === "ACCESSORY"
  )
  const pdpPricingHierarchyExp = useSelector(
    (state) => state.experiment.pdpPricingHierarchy.variant_id
  )

  const holidayStyle = showHolidayShippingInfoPDP() && holidayDelivery
  const cutoffStyle = showHolidayShippingInfoPDP() && !holidayDelivery

  if (holidayStyle) {
    // const arriveBy =
    //   new Date(minDeliveryDate).getDate() ==
    //   new Date(sl.config.guaranteed_receive_date).getDate()
    const text = `${
      sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday
    } ${jewlr_t("terms.Shipping")}`
    // ship.view_type === "AVAILABLE_HOLIDAY"
    //   ? // ? ` Arrives ${arriveBy ? "By" : "Before"} ${
    //     `Arrives Before ${
    //       sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday
    //     }`
    //   : `${
    //       sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday
    //     } Shipping Info`
    // `${sl.config.guaranteed_holiday} ${jewlr_t("terms.Shipping")} Info`
    // const text = `${sl.config.guaranteed_holiday} Shipping Info`
    return (
      <div
        className={cn(
          pdpPricingHierarchyExp === 1
            ? "text-black-print mb-12 flex items-center justify-center"
            : "text-sale mb-12 flex items-center justify-center"
        )}
      >
        <FontAwesomeIcon
          className="text-16 tablet:text-18 mr-8 align-text-top"
          icon={faShippingFast}
        />
        <h2
          className={cn(
            pdpPricingHierarchyExp === 1
              ? "text-16 tablet:tracking-tight leading-20 font-semibold"
              : "text-16 tablet:text-18 tablet:font-medium tablet:tracking-tigher leading-20 font-semibold"
          )}
        >
          {text}
        </h2>
      </div>
    )
  }
  return (
    <div
      className={cn(
        "flex items-center justify-center",
        pdpPricingHierarchyExp === 0 && cutoffStyle
          ? "mb-22 desktop:mb-10"
          : "mb-8"
      )}
    >
      {IS_JEWLR() ? (
        <>
          <FontAwesomeIcon
            className="text-18 mr-4 align-text-top"
            icon={faGift}
          />
          <h2
            className={cn(
              "text-16 tablet:text-18 font-semibold",
              pdpPricingHierarchyExp === 0 &&
                (cutoffStyle
                  ? "tablet:font-bold leading-16 tracking-tighter"
                  : "tablet:font-medium")
            )}
          >
            {isAccessory
              ? `${jewlr_t("terms.Shipping")} Information`
              : "Custom made for you!"}
          </h2>
        </>
      ) : (
        <>
          <FontAwesomeIcon
            className="text-22 mr-4 align-text-top"
            icon={faShippingFast}
          />
          <h2
            className={cn(
              "text-16 tablet:text-18 font-semibold",
              pdpPricingHierarchyExp === 0 &&
                (cutoffStyle
                  ? "tablet:font-bold leading-16 tracking-tighter"
                  : "tablet:font-medium")
            )}
          >
            {jewlr_t("terms.Shipping")} Info
          </h2>
        </>
      )}
    </div>
  )
}

export default Title
